import React from 'react'
import WaterMarkPage from './_shared/WaterMarkPage'
import TermsOfUseTemplate from './templates/TermsOfUseTemplate'
import Page from '../../../components/pdf/Page'
import CertificateTemplate from './templates/certificates/CertificateTemplate'
import ETCServiceOrdersTemplate from './templates/serviceOrders/ETCServiceOrdersTemplate'
import OSHeavyMachinesTemplate from './templates/serviceOrders/OSHeavyMachinesTemplate'
import CertificateWithImageTemplate from './templates/certificates/CertificateWithImageTemplate'

const PdfDocument = ({ templateId }) => {
  const content = () => {
    if (templateId === 1) {
      return (
        <WaterMarkPage>
          <TermsOfUseTemplate />
        </WaterMarkPage>
      )
    }

    if (templateId === 2) {
      return <Page>{<OSHeavyMachinesTemplate />}</Page>
    }

    if ([3, 4, 5].includes(templateId)) {
      return <Page>{<ETCServiceOrdersTemplate templateId={templateId} />}</Page>
    }

    if ([6, 7, 8, 9, 10].includes(templateId)) {
      return <Page>{<CertificateTemplate templateId={templateId} />}</Page>
    }

    if (templateId === 11) {
      return <Page>{<CertificateWithImageTemplate templateId={templateId} />}</Page>
    }
  }
  return <>{content()}</>
}

export default PdfDocument
